import { PublishingItemDTO } from '../dtos/PublishingItem.dto';
import { PublishingItemModel } from '../models/PublishingItem.model';

export class PublishingUtil {
  public static mapToViewModel(dto: PublishingItemDTO): PublishingItemModel {
    return {
      id: dto.id,
      community: dto.community,
      baseType: dto.baseType,
      display: dto.displayType,
      title: dto.heading,
      subTitle: dto.body,
      status: dto.status,
      access: dto.access,
      scheduledDate: dto.publishingOn,
      publishedDate: dto.publishedDate,
    };
  }
}
